import React from "react";
import { useTranslation } from "react-i18next";
import CardHeader from "../ui/CardHeader";
import Sparkline from "../charts/Sparkline";
import { formatInt } from "../../utils/formatters";

/**
 * CallsPerDayCard — `flat-card` wrapper around a single sparkline showing
 * call volume per day across the selected range.
 *
 * Props:
 *   series:    { date: string, count: number }[]
 *   className: extra classes for the outer card (e.g. `lg:col-span-2`)
 */
const CallsPerDayCard = ({ series, className = "" }) => {
  const { t } = useTranslation();
  const max = Math.max(1, ...series.map((p) => p.count));
  const total = series.reduce((acc, p) => acc + p.count, 0);

  return (
    <div className={`flat-card rounded-xl p-6 sm:p-8 ${className}`}>
      <CardHeader
        icon="show_chart"
        title={t("analytics.callsPerDay.title")}
        subtitle={t("analytics.callsPerDay.subtitle", {
          calls: formatInt(total),
          days: series.length,
        })}
      />
      <Sparkline
        points={series.map((p) => p.count)}
        max={max}
        ariaLabel={t("analytics.callsPerDay.title")}
      />
      <div className="mt-2 flex justify-between text-[11px] font-mono text-on-surface-light-variant/70 dark:text-on-surface-variant/70">
        <span>{series[0]?.date ?? ""}</span>
        <span>{series[series.length - 1]?.date ?? ""}</span>
      </div>
    </div>
  );
};

export default CallsPerDayCard;
